import { AuthLayout } from "@/components/layouts/AuthLayout";
import { Button } from "@/components/ui/shadcn/button";
import { Heading, Text } from "@/components/ui/Typography";
import { AlertTriangle } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router";
import { animDelay } from "@/lib/utils";

const defaultDescription =
  "We couldn't sign you in. Please try again. If the problem persists, please contact support at support@rentinit.ae";

const errorDescriptionMap: Record<string, string> = {
  access_denied: "User cancelled the login",
  invalid_request: "User cancelled the login",
  cancelledOnApp: "User cancelled the login",
  cancelledOnProvider: "User cancelled the login",
  SOP_NOT_ALLOWED:
    "You are not eligible to access this service. Your account is either not upgraded or you have a visitor account. Please contact us at support@rentinit.ae to access the services.",
  error:
    "Something went wrong during the login, please try again later or contact us at support@rentinit.ae",
  unknown_error:
    "Something went wrong during the login, please try again later or contact us at support@rentinit.ae",
};

function SigninError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  const description = error
    ? (errorDescriptionMap[error] ?? defaultDescription)
    : defaultDescription;

  return (
    <AuthLayout>
      <div className="relative flex w-full max-w-md flex-col items-center text-center">
        <div className="anim-scale-in flex size-20 items-center justify-center rounded-xl bg-destructive/10">
          <AlertTriangle size={36} className="text-destructive" />
        </div>

        <div className="anim-slide-up" style={animDelay(150)}>
          <Heading
            variant="h1"
            weight="medium"
            className="mt-6 text-3xl sm:text-3xl"
          >
            Sign in failed
          </Heading>
        </div>

        <div className="anim-fade-in" style={animDelay(250)}>
          <Text variant="text3" className="mt-2 text-muted-foreground">
            {description}
          </Text>
        </div>

        <div className="anim-slide-up mt-8 w-full" style={animDelay(350)}>
          <Button onClick={() => navigate("/signin")} className="w-full">
            Back to sign in
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
}

export default SigninError;
